import _ from 'underscore';
import sortedLastIndexBy from 'lodash/sortedLastIndexBy';
import lastIndex from 'lodash/sortedLastIndexBy';
import mxtend from 'xtend/mutable';
import inherits from 'inherits';
import parse from 'date-fns/parse';
import isWithinRange from 'date-fns/is_within_range';
import ListStore from '@nichoth/state/list';

function EventsStore () {
    if (!(this instanceof EventsStore)) return new EventsStore();
    ListStore.call(this);
}
inherits(EventsStore, ListStore);

mxtend(EventsStore.prototype, {
    idKey: 'eventID',
    sortBy: 'startDateTime',

    add: function (item) {
        var self = this
        // don't update if already exists
        if (self._state.data[item[self.idKey]]) return

        self._state.data[item[self.idKey]] = item
        var i = sortedLastIndexBy(self._state.sorted, item, function (item) {
            return item[self.sortBy]
        })
        self._state.sorted.splice(i, 0, item)
        return self.publish()
    },

    isWithinPage: function (maxResults, isAscending, event) {
        if (!this._state.sorted.length) return true;

        var start = parse(isAscending ?
            this._state.sorted[0].startDateTime :
            this._state.sorted[this._state.sorted.length - 1].startDateTime
        );

        var end = parse(this._state.sorted[isAscending ?
            this._state.sorted.length - 1 : 0].startDateTime);

        if (!start || !end || start > end) {
            // isWithinRange requires start <= end
            return false
        }
        return maxResults > this._state.sorted.length ?
            true :
            isWithinRange(event.startDateTime, start, end);
    },

    encoderOnline: function (enc, val) {
        var didUpdate = false;
        this._state.sorted.forEach(function (ev) {
            if (ev.assignedEncoder !== enc.encoderID) return;
            didUpdate = true;
            ev.encoderDetails.online = val;
        });
        return didUpdate ? this.publish() : this;
    },

    encoderConnect: function (enc) {
        return this.encoderOnline(enc, true);
    },

    encoderDisconnect: function (enc) {
        return this.encoderOnline(enc, false);
    },

    updateCategory: function (prev, newCat) {
        return metadataUpdate(this, 'categories', 'categoryName', prev, newCat);
    },

    updateKeyword: function (prev, newKeyword) {
        return metadataUpdate(this, 'keywords', 'keyword', prev, newKeyword);
    },

    updateFacebookLive: function (method, data) {
        let evID = trimEventID(data.eventID);

        if (evID && this._state.data.hasOwnProperty(evID)) {
            switch (method) {
                case 'add':
                    this._state.data[evID].facebookLive = data;
                    break;

                case 'delete':
                    this._state.data[evID].facebookLive = null;
                    break;
            }

            return this.publish();
        }

        return this;
    },

    addAsset: function (asset) {
        // these are sorted by name
        var ev = this._state.data[asset.eventID];
        if (!ev) return this;
        var exists = _.findWhere(ev.mediaAssets, {
            assetID: asset.assetID
        });

        if (exists) return this.updateAsset(asset);

        var i = lastIndex(ev.mediaAssets, asset, function (_asset) {
            return _asset.name;
        });
        ev.mediaAssets.splice(i, 0, asset);
        return this.publish();
    },

    deleteAsset: function (asset) {
        if (!this._state.data[asset.eventID]) return this;
        var i = _(this._state.data[asset.eventID].mediaAssets)
            .findIndex(a => a.assetID === asset.assetID);
        if (i === -1) return this;
        this._state.data[asset.eventID].mediaAssets.splice(i, 1);
        return this.publish();
    },

    updateAsset: function (asset) {
        if (!this._state.data[asset.eventID]) return this;
        var i = _(this._state.data[asset.eventID].mediaAssets)
            .findIndex(a => a.assetID === asset.assetID);
        if (i === -1) return this;
        this._state.data[asset.eventID].mediaAssets[i] = asset;
        return this.publish();
    },

    setAssets: function (eventID, assets) {
        if (!this._state.data[eventID]) return this;
        this._state.data[eventID].mediaAssets = assets;
        return this.publish();
    },

    // @FIXME this is a duplicate key -- which method is the on we want
    // updateFacebookLive: function (fbData) {
    //     if (!this._state.data[fbData.eventID]) return this;
    //     mxtend(this._state.data[fbData.eventID], {
    //         facebookLive: fbData
    //     });
    //     return this.publish();
    // },

    deleteFacebookLive: function (data) {
        if (!this._state.data[data.eventID]) return this;
        this._state.data[data.eventID].facebookLive = null;
        return this.publish();
    }
});

function metadataUpdate (store, listName, nameKey, prev, newItem) {
    var didUpdate = false;
    store._state.sorted.forEach(function (ev) {
        var i = (ev[listName] || []).indexOf(prev[nameKey]);
        if (i === -1) return;
        ev[listName].splice(i, 1, newItem[nameKey]);
        didUpdate = true;
    });
    if (didUpdate) return store.publish();
    return store;
}

function trimEventID (eventID) {
    try {
        if (eventID.indexOf('_') > 0) {
            return eventID.split('_')[1]
        } else {
            return eventID;
        }
    } catch (e) {
        console.warn('trimEventID', eventID, e);
        return false;
    }
}

export default EventsStore;
